import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',

    lineHeight: '28px',
    fontSize: '14px',
    color: '#C4C4C4',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'center',

    padding: 10,

    '& .footer-bar-message': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& *': {
        margin: '0px 2px',
      },
    },
  },
})
export default styleOverride
